import { css } from '@emotion/react'
import { memo } from 'react'
import i18n from '../../../utilities/i18n'
import Button from '../../Buttons/Button'
import Progress from '../Progress'
import {
    junkStyles,
    refreshStyles,
    reload,
    rootStyles,
    verificationStyles,
} from './shared'

type SignupSuccessProps = {
    email: string
}

const emailStyles = css({ fontSize: '1rem' })

const SignupSuccess = memo((props: SignupSuccessProps) => {
    const { email } = props
    return (
        <div css={rootStyles}>
            <h4 className="typography gutter-bottom centered">
                {i18n.t('signup.thankYouForSigningUp')}
            </h4>
            <p className="typography gutter-bottom" css={emailStyles}>
                {i18n.t('signup.sentEmail')}
                <b>{email}</b>. {i18n.t('signup.openEmailClickLink')}
            </p>
            <div css={junkStyles}>{i18n.t('signup.checkSpam')}</div>
            <h6 className="typography gutter-bottom centered">
                {i18n.t('signup.awaitingVerification')}
            </h6>
            <Progress />
            <div css={verificationStyles}>
                {i18n.t('signup.ifVerifiedButMessagePersists')}
            </div>
            <Button onClick={reload} css={refreshStyles} size="medium">
                {i18n.t('signup.refresh')}
            </Button>
        </div>
    )
})

export default SignupSuccess
